import { appendImageFormatParameters } from '@/utils/contentful-image-paths/contentful-image-paths';
import NextImage from 'next/image';
import styles from './card-image.module.scss';

export type CardImageType = {
  src: string;
  alt: string;
  height?: number;
  width?: number | null;
  quality?: number;
  className?: string;
};

const CardImage = ({ image }: { image: CardImageType }) => {
  const { src, alt, width, height, quality, className } = image;

  const imageCropURL = image
    ? appendImageFormatParameters({
        url: src,
        maxWidth: width ?? 600,
        maxHeight: height ?? 327,
        quality: quality ?? 70,
      })
    : '';

  return (
    <div className={`${styles['card-image']} ${className ?? ''}`}>
      <NextImage
        src={imageCropURL}
        alt={alt}
        width={width ?? undefined}
        height={height ?? undefined}
        quality={quality ?? 70}
      />
    </div>
  );
};

export default CardImage;
